


import TiwiMixin from '../mixins/TiwiMixin'
import ContentActions from './ContentActions.vue'
import ContentIcon from './ContentIcon.vue'
import ActivityIndicator from './ActivityIndicator.vue'
import RatingWidget from './RatingWidget.vue'


export default {
  mixins: [TiwiMixin],
  components: { ContentIcon, ContentActions, RatingWidget, ActivityIndicator },
  props: {
    post: {
      required: true,
      type: Object,
    },
    isVertical: {
      required: false,
      type: Boolean,
      default: false,
    },
    disableActions: {
      required: false,
      type: Boolean,
      default: false,
    },
    showInOverlay:{
      required: false,
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {

    }
  },
  mounted: () => {
    // Eseguito al mount
  },
  computed: {
    postTypeMeta() {
      return this.getPostTypeMeta(this.post.type);
    },
    parse_rating() {
      return Array(5).fill(0).map((_, i) => (this.post.stats?.rating > i));
    },
    author_display() {
      return (
        this.post.author.label == 'communiti' || this.post.author.label == 'occhiovolante')
        ? '' : this.post.author.label;
    },
    post_categories() {
      if (this.post.type == 'kit' && this.post.topics) {
        return Object.entries(this.post.topics)
          .filter(t => t[0])
          .map(([slug, name]) => ({ slug, name }));
      }

      return [];
    },


    icon_label() {
      return (this.post.type == 'pcto' && this.post.type_detail) ? this.post.type_detail : 
        (this.post.type == 'story' && this.post?.topic?.name) ? this.post.topic.name : null;
    }
  },
  methods: {
    handleLink: function( event ){

      if(this.showInOverlay){
        event.preventDefault();
        
      var self = this;
      self.setLoading(true);


      this.api.get('posts/getOverlayContent?post_id=' + this.post.ID )
        .then( (response) => {
      
          if( response.data.success ){
          
            if(response.data.content){
              self.setOverlay({ content: response.data.content, url: response.data.url } );
            }
              
            
          }
          else{
            self.toast.error( response.data.message );
            
          }
            
        })
        .catch( (error) => { 
          console.log( error );
          self.toast.error( 'Errore nella richiesta' );
        })
        .finally( () => self.setLoading(false) )
        
      }

    }
  },
}
